import i18n from "i18next";

export interface DropdownOption {
    label: string
    value: any
    data?: any
}

export const VehicleTypeOptions: DropdownOption[] = [
    {value: 1, label: `${i18n.t('Kamion')}`},
    {value: 2, label: `${i18n.t('Kamion sa prikolicom')}`},
    {value: 3, label: `${i18n.t('Kombi')}`},
    {value: 4, label: `${i18n.t('Traktor')}`},
    {value: 5, label: `${i18n.t('Vagon')}`},
    {value: 6, label: `${i18n.t('Automobil')}`}
];

export const decodeVehicleType = (typeIdString?: string): string => {
    let typeId = 0
    if (typeIdString) {
        typeId = parseInt(typeIdString)
    }
    switch (typeId) {
        case 1:
            return `${i18n.t('Kamion')}`;
        case 2:
            return `${i18n.t('Kamion sa prikolicom')}`;
        case 3:
            return `${i18n.t('Kombi')}`;
        case 4:
            return `${i18n.t('Traktor')}`;
        case 5:
            return `${i18n.t('Vagon')}`;
        case 6:
            return `${i18n.t('Automobil')}`;
    }
    return `${i18n.t('Nepoznat tip: ')}` + typeId
}
